module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution5.675cfdcf.png";